(function () {
  var root = document.querySelector('[data-pv-look]');
  if (!root) return;
  var style = root.dataset.style, colour = root.dataset.colour, self = root.dataset.handle;
  if (!style) return;
  var row = root.querySelector('[data-pv-look-row]');
  var elDeal = root.querySelector('[data-pv-look-deal]');
  var elWas = root.querySelector('[data-pv-look-was]');
  var btn = root.querySelector('[data-pv-look-buy]');
  var pct = parseInt(root.dataset.pct, 10) || 15;
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(c) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'sv', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function subject(tags) {
    var s = '';
    (tags || []).forEach(function (t) { if (!s && t.indexOf('subject:') === 0) s = t; });
    return s;
  }
  function fetchList(tags) {
    return fetch(rootUrl + 'collections/all/' + tags.join('+') + '?view=pvjson')
      .then(function (r) { return r.json(); })
      .catch(function () { return { products: [] }; });
  }

  function build(list, mySubject) {
    var picked = [], seen = {};
    list.forEach(function (p) {
      if (picked.length >= 2) return;
      if (p.handle === self) return;
      var s = subject(p.tags);
      if (s && (s === mySubject || seen[s])) return;
      seen[s] = true;
      picked.push(p);
    });
    return picked;
  }

  fetch(rootUrl + 'products/' + self + '.js')
    .then(function (r) { return r.json(); })
    .then(function (me) {
      var mySubject = subject(me.tags);
      return fetchList(colour ? [style, colour] : [style]).then(function (d) {
        var picked = build(d.products || [], mySubject);
        if (picked.length < 2) {
          return fetchList([style]).then(function (d2) { return { me: me, picked: build(d2.products || [], mySubject) }; });
        }
        return { me: me, picked: picked };
      });
    })
    .then(function (res) {
      if (!res || res.picked.length < 2) return;
      return Promise.all(res.picked.map(function (p) {
        return fetch(rootUrl + 'products/' + p.handle + '.js').then(function (r) { return r.json(); });
      })).then(function (full) {
        var all = [res.me].concat(full);
        row.innerHTML = '';
        var sum = 0;
        all.forEach(function (p) {
          sum += p.price;
          var a = document.createElement('a');
          a.href = rootUrl + 'products/' + p.handle;
          a.className = 'pv-look-item';
          a.innerHTML = '<img loading="lazy" src="' + (p.featured_image || '') + '" alt=""><span>' + p.title + '</span>';
          row.appendChild(a);
        });
        elDeal.textContent = money(Math.round(sum * (100 - pct) / 100));
        elWas.textContent = money(sum);
        root.hidden = false;
        btn.addEventListener('click', function () {
          if (!window.PvBundleDrawer) return;
          window.PvBundleDrawer.open({
            name: root.dataset.name,
            pct: pct,
            products: all.map(function (p) {
              return {
                title: p.title,
                url: rootUrl + 'products/' + p.handle,
                image: p.featured_image,
                variants: p.variants.map(function (v) {
                  return { id: v.id, size: v.option1, frame: v.option2 || '', price: v.price, available: v.available };
                })
              };
            })
          });
        });
      });
    })
    .catch(function () {});
})();
